/**
 * Given a `region`, return lazily the matching configuration.
 */
export async function getConfiguration(onboardingConfigurationId: string) {
  switch (onboardingConfigurationId) {
    /*** California ***/
    /** @deprecated please use `ca-ukg` instead */
    case "ca":
      return (await import("./ca")).CaliforniaConfiguration;
    case "ca-ukg":
      return (await import("./ca-ukg")).CaliforniaUKGConfiguration;
    /*** New Jersey ***/
    case "nj":
      return (await import("./nj")).NewJerseyConfiguration;
    /*** Fallback ***/
    default: {
      throw new Error(`No configuration found for ${onboardingConfigurationId}`);
    }
  }
}
